import { useContext, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import { columns, customStyles, opcionesdepagina } from '../tableOptions';
import ExcelExport from '../dataExcelExport';
import { Button } from '@mui/material';
import ModalCambiarPrecio from '../ModalCambiarPrecio';
import { AdminContext } from '../../../context/AdminContext';
import { ProductContext } from '../../../context/ProductContext';
import { SNACKBAR_SEVERITY } from '../../../constants';
import BarcodeModal from '../BarcodeModal';
import LabelPrinterModal from '../LabelPrinter';

function ProductTable({ setSelectedRows, selectedRows, modificarProducto, data, omitDate, omitCodigo, columnas, toggleCleared, setToggleCleared }) {
  //Context
  const { handleClickSnackbar } = useContext(AdminContext);
  const { totalRows, borrarUnProducto, publicacionMasiva, setFilterState, filterState } = useContext(ProductContext);
  // States
  const [modalCambiarPrecio, setModalCambiarPrecio] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState('');
  const [codigo, setCodigo] = useState('')
  const [descripcion, setDescripcion] = useState("")
  const [validPrintData, setValidPrintData] = useState([]);
  const [modalPrint, setModalPrint] = useState(false);
  const [isPageChanging, setIsPageChanging] = useState(false);
  const [error, setError] = useState(null);

  const handlePublicar = async () => {
    if (selectedRows.length === 0) {
      handleClickSnackbar('Seleccione productos para publicar', SNACKBAR_SEVERITY.warning);
      return;
    }

    // confecciona el mensaje a mostrar
    let confirmString = '';
    selectedRows.map(r => (confirmString += r.descripcion + '\n'));

    if (window.confirm(`Esta seguro que quiere publicar:\n\n ${confirmString}?`)) {
      const idsDeProductos = selectedRows.map(row => row._id);
      const exito = await publicacionMasiva(idsDeProductos);
      if (exito) {
        handleClickSnackbar('Productos publicados', SNACKBAR_SEVERITY.success);
        setToggleCleared();
      } else {
        handleClickSnackbar('Ocurrio un error al publicar los productos', SNACKBAR_SEVERITY.error);
      }
    }
  };

  const handleRowSelected = ({ selectedRows: newSelectedRows }) => {
    setSelectedRows(newSelectedRows);
  };

  const handleCambiarPrecio = () => {
    if (selectedRows.length === 0) {
      handleClickSnackbar('Seleccione productos para cambiar el precio', SNACKBAR_SEVERITY.warning);
      return;
    }
    setModalCambiarPrecio(true);
  };

  const handlePrintAllClick = () => {
    if (selectedRows.length === 0) {
      handleClickSnackbar('Seleccione productos para imprimir etiquetas', SNACKBAR_SEVERITY.warning);
      return;
    }

    const validItems = selectedRows.filter(item => (item.descripcion && item.descripcion !== "") && (item.codigoProducto && item.codigoProducto !== ""))
    setValidPrintData(validItems)
    if (validItems.length > 0) {
      setModalPrint(true);
    } else {
      handleClickSnackbar('Los productos seleccionados no tienen datos válidos para imprimir', SNACKBAR_SEVERITY.warning);
    }
  };

  const handleModalPrint = () => {
    setModalPrint(prev => !prev);
  };

  const toggleCambiarPrecio = () => {
    setModalCambiarPrecio(prev => !prev);
  };

  async function deleteAndInform(_id) {
    const exito = await borrarUnProducto(_id);
    if (exito) handleClickSnackbar('Producto borrado con exito', SNACKBAR_SEVERITY.success);
    else handleClickSnackbar('No fue posible borrar el producto', SNACKBAR_SEVERITY.error);
  }

  function imprimirCodigo(row) {
    setOpen(true)
    setCodigo(row.codigoProducto);
    setId(row.UserId);
    setDescripcion(row.descripcion.substr(0, 20) + row.talle.substr(0, 21) + row.marca.substr(0, 21));
  }

  function closeBarcodeModal() {
    setOpen(false)
    setCodigo('');
    setId('');
  }

  // Pagination functions with error handling
  const cambiarDisplay = async (newPerPage, page) => {
    try {
      console.log('cambiarDisplay', newPerPage, page);
      setIsPageChanging(true);
      setError(null);
      await setFilterState(prev => ({ ...prev, display: newPerPage, page }));
    } catch (err) {
      setError('Error al cambiar el número de filas por página');
      handleClickSnackbar('Error al cambiar el número de filas por página', SNACKBAR_SEVERITY.error);
    } finally {
      setIsPageChanging(false);
    }
  }

  const cambiarPagina = async (page) => {
    try {
      setIsPageChanging(true);
      setError(null);
      await setFilterState(prev => ({ ...prev, page }));
    } catch (err) {
      setError('Error al cambiar de página');
      handleClickSnackbar('Error al cambiar de página', SNACKBAR_SEVERITY.error);
    } finally {
      setIsPageChanging(false);
    }
  }

  const contextMenuItems = useMemo(() => {
    if (!selectedRows?.length) return null;

    return (
      <div style={{
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        display: 'flex',
        gap: '8px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}>
        <Button variant="contained" onClick={handlePublicar} style={{ backgroundColor: 'orange', color: 'white' }}>
          Publicar ({selectedRows.length})
        </Button>
        <ExcelExport datos={selectedRows} />
        <Button variant="contained" onClick={handleCambiarPrecio} style={{ backgroundColor: 'orange', color: 'white' }}>
          Cambiar Precio ({selectedRows.length})
        </Button>
        <Button variant="contained" onClick={handlePrintAllClick} style={{ backgroundColor: 'orange', color: 'white' }}>
          Imprimir Etiqueta ({selectedRows.length})
        </Button>
      </div>
    );
  }, [selectedRows, handlePublicar, handleCambiarPrecio, handlePrintAllClick]);

  return (
    <>
      <BarcodeModal open={open} UserId={id} codigoProducto={codigo} closeModal={closeBarcodeModal} descripcion={descripcion} />
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {selectedRows?.length > 0 && contextMenuItems}
        {error && (
          <div style={{ color: 'red', padding: '8px', textAlign: 'center' }}>
            {error}
          </div>
        )}
        <DataTable
          responsive
          columns={columnas ? columnas : columns(deleteAndInform, imprimirCodigo, omitDate, omitCodigo)}
          data={data}
          customStyles={{
            ...customStyles,
            headRow: {
              style: {
                backgroundColor: '#f7f7f9',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: '#e0e0e0',
              }
            },
            rows: {
              style: {
                minHeight: '48px',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              },
              selectedHighlightStyle: {
                backgroundColor: '#e3f2fd',
                color: 'black',
                '&:hover': {
                  backgroundColor: '#e3f2fd',
                },
              },
            },
          }}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          keyField='_id'
          paginationComponentOptions={{
            ...opcionesdepagina,
            noRowsPerPage: false,
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todo',
            rangeSeparatorText: 'de',
            rowsPerPageText: 'Filas por página',
          }}
          fixedHeader
          fixedHeaderScrollHeight='600px'
          highlightOnHover
          selectableRows
          selectableRowsHighlight
          selectableRowsVisibleOnly={false}
          persistSelectedOnSort
          paginationDefaultPage={filterState.page}
          paginationPerPage={filterState.display}
          onChangeRowsPerPage={cambiarDisplay}
          onChangePage={cambiarPagina}
          contextActions={contextMenuItems}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          onRowClicked={(row) => modificarProducto(row)}
          noDataComponent={<div>No hay información disponible para mostrar</div>}
          progressPending={isPageChanging}
          progressComponent={<div style={{ padding: '24px' }}>Cargando...</div>}
        />
      </div>
      <ModalCambiarPrecio 
        selectedRows={selectedRows} 
        modal={modalCambiarPrecio} 
        toggleModal={toggleCambiarPrecio} 
        clearSelection={setToggleCleared} 
      />
      <LabelPrinterModal modal={modalPrint} handleClose={handleModalPrint} data={validPrintData} />
    </>
  );
}

ProductTable.propTypes = {
  productosFiltrados: PropTypes.array,
  selectedRows: PropTypes.array,
  setSelectedRows: PropTypes.func.isRequired,
  modificarProducto: PropTypes.func,
  data: PropTypes.array.isRequired,
  omitDate: PropTypes.bool.isRequired,
  omitCodigo: PropTypes.bool.isRequired,
  columnas: PropTypes.array,
  toggleCleared: PropTypes.bool,
  setToggleCleared: PropTypes.func,
};

export default ProductTable;
